
<mat-dialog-content >

  <mat-form-field style="margin-right: 10px">
    <input  matInput name="caracteristique_Model" [matAutocomplete]="caracteristiqueModel"
        (input)="onCaracteristiqueModelValuechange($event)" #caracteristique_Model="ngModel" [(ngModel)]="azerty"
        placeholder="Modèle" required>
  </mat-form-field>
  <mat-autocomplete #caracteristiqueModel="matAutocomplete" [displayWith]="setTextInput" (optionSelected)="caracteristiqueModelSelected($event)">
    <mat-option *ngFor="let option of listeCaracteristiqueModel" [value]="option">
    {{option.ecArtCarMod_Label}}
    </mat-option>
  </mat-autocomplete>
</mat-dialog-content>

<mat-dialog-actions>
  <button class="mat-raised-button" (click)="close()">Close</button>
  <button class="mat-raised-button mat-primary" (click)="save()">Choisir</button>
</mat-dialog-actions>